import React from 'react'
import Navigation from '../Navigation/Navigation';
import './Navbar.css';


const MainHeader = () => {

  return (
    <header className="main-header">
      <a className="logo" href="/">
        <div className="proforum-logo">
          <img src="/images/logos/proforum.jpg" alt="Proforum" />
          <span className="logo-lg"><strong> NDC PROFORUM</strong></span>
        </div>
      </a>
      <nav className="navbar navbar-static-top" role="navigation">
        <div className="navbar-custom-menu">
          <Navigation />
        </div>
      </nav>
    </header>
  )
}

export default MainHeader
